import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface UploadFileConfirmationData {
  fileName: string;
  /** Local file selected for upload — shows embedded preview before confirm */
  file?: File;
  /** Remote PDF URL — preview-only dialog (e.g. uploaded handbook) */
  pdfUrl?: string;
}

@Component({
  selector: 'app-upload-file-confirmation',
  templateUrl: './upload-file-confirmation.component.html',
  styleUrls: ['./upload-file-confirmation.component.scss']
})
export class UploadFileConfirmationComponent implements OnDestroy {
  previewUrl: SafeResourceUrl | null = null;
  private objectUrl: string | null = null;

  get isUploadMode(): boolean {
    return !!this.data?.file;
  }

  constructor(
    public dialogRef: MatDialogRef<UploadFileConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadFileConfirmationData,
    private sanitizer: DomSanitizer
  ) {
    if (this.data?.file instanceof File) {
      this.objectUrl = URL.createObjectURL(this.data.file);
      this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `${this.objectUrl}#toolbar=0&navpanes=0&scrollbar=0`
      );
    } else if (this.data?.pdfUrl) {
      const url = this.data.pdfUrl.includes('#')
        ? `${this.data.pdfUrl}&toolbar=0&navpanes=0&scrollbar=0`
        : `${this.data.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`;
      this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}